import $ from "jquery";
import Siema from "siema";
Siema.prototype.setAutoHeight = function (stopTime) {
    var that, timeout;
    that = this;
    function autoHeight() {
        var currentItems, min, max, itemHeightList, height, maxHeight, i;
        min = that.currentSlide;
        max = min + that.perPage;
        itemHeightList = [];
        for (i = min; i < max; i++) {
            height = parseInt(that.innerElements[i].scrollHeight, 10);
            itemHeightList.push(height);
        }
        maxHeight = Math.max.apply(null, itemHeightList);
        $(that.selector).animate({ height: maxHeight }, 250);
        that.sliderFrame.style.maxHeight = maxHeight + 'px';
    }
    window.addEventListener('resize', function () {
        that.sliderFrame.style.maxHeight = '';
        clearTimeout(timeout);
        timeout = setTimeout(autoHeight, 500);
    });
    autoHeight();
};
export function sliderWrapper() {
    if ($(".sliderWrapper").length) {
        var sliders_1 = {};
        $('.sliderWrapper').each(function (k, v) {
            var siema = $(v).find(".siema").get(0);
            var controlNavigation = $(v).find(".siema-slider-nav");
            var hasTimer = $(v).hasClass("has-timer");
            var controls = $(v).attr("data-controls");
            var draggable = $(v).attr("data-draggable");
            var autoheight = $(v).attr("data-autoheight");
            var name = $(v).attr("data-name");
            var hasControls = (controls != "");
            var interval;
            var navigation = $(v).find(".navigation");
            var slider = new Siema({
                selector: siema,
                duration: 300,
                easing: 'ease-out',
                perPage: 1,
                startIndex: 0,
                draggable: draggable == "true" ? true : false,
                multipleDrag: false,
                threshold: 20,
                loop: false,
                rtl: false,
                onInit: function () {
                    navigation.find("span:eq(0)").addClass("current");
                },
                onChange: function () {
                    if (hasTimer) {
                        clearInterval(interval);
                        interval = setInterval(function () { return slider.next(); }, 5000);
                    }
                    navigation.find(".current").removeClass("current");
                    navigation.find("span:eq(" + slider.currentSlide + ")").addClass("current");
                    if (hasControls) {
                        $(controls).children(".current").removeClass("current");
                        $(controls).children("li:eq(" + slider.currentSlide + ")").addClass("current");
                    }
                    if (autoheight == 1) {
                        slider.setAutoHeight();
                    }
                }
            });
            if (autoheight == 1) {
                slider.setAutoHeight();
            }
            $(window).resize(function () {
                if (autoheight == 1) {
                    slider.setAutoHeight();
                }
                slider.resizeHandler();
            });
            sliders_1[name] = slider;
            $(window).on("keydown", function (event) {
                var key = event.keyCode;
                if (key == 39)
                    slider.next();
                if (key == 37)
                    slider.prev();
            });
            controlNavigation.on("click", "a", function (e) {
                if ($(e.currentTarget).hasClass("left"))
                    slider.prev();
                if ($(e.currentTarget).hasClass("right"))
                    slider.next();
            });
            if (hasTimer) {
                interval = setInterval(function () { return slider.next(); }, 5000);
            }
            navigation.on("click", "span", function (e) {
                e.preventDefault();
                slider.goTo($(e.currentTarget).index());
            });
            if (hasControls) {
                $(controls).on("click", "a", function (e) {
                    e.preventDefault();
                    if ($(e.currentTarget).hasClass("arrow")) {
                        if ($(e.currentTarget).hasClass("left"))
                            slider.prev();
                        if ($(e.currentTarget).hasClass("right"))
                            slider.next();
                    }
                    else {
                        slider.goTo($(e.currentTarget).parent().index());
                    }
                });
            }
        });
    }
}
;
